import { render, staticRenderFns } from "./ProtocolListContainerView.vue?vue&type=template&id=bb2a5494&"
import script from "./ProtocolListContainerView.vue?vue&type=script&lang=js&"
export * from "./ProtocolListContainerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports